import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Grid from "@material-ui/core/Grid";
import { getFormattedImageLink, getFormattedDateTime } from "Utils";
import ProfilePicture from "Component/Thumbnail/ProfilePicture";


export default class Activity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profileimage: this.props.profileimage,
      hover: false,
      fullname: null,
      imageindex: null,
    };
    this.onHover = this.onHover.bind(this);
  }

onHover(value, index) {
    this.setState({
      hover: !this.state.hover,
      fullname: value,
      imageindex: index,
    });
  }

  render() {
    return (
      <div
        className="thin-scroll"
        style={{ height: "96vh", overflowY: "auto", paddingRight: 15 }}
      >
        <div className="margin-bottom-16">
          <Grid container >

            <Grid item xs={12} md={12} sm={12}>
             {this.props.activityobjective.length !== 0 && this.props.activityobjective.map((x, index) =>
              
            
                <div
                  style={{
                    borderBottom: "1px solid #d8d8d8",
                    marginBottom: 4,
                    padding: 8,
                    position: "relative",
                  }}
                >
                  <Grid container>
                    

                    <Grid item md={8} sm={12}>
                      <Tooltip title={x.fullname} placement="top">
                        <div style={{ width: 32, marginRight: 8 }}>

                          <ProfilePicture
                            src={getFormattedImageLink(x.imagepath)}
                            height="32"
                            classname="floatleft margin-right-16"

                          />

                        </div>
                      </Tooltip>
                      <div className="floatleft "   >
                        <p className="small-dark-secondary  t-bold">
                          {x.activitytypeid == 1 ? "OKR was created" : x.activitytypeid == 2 ? "OKR was modified" : x.activitytypeid == 3 ? "Status was updated" : x.activitytypeid == 4 ? "Type was modified" : x.activitytypeid == 5 ? "Task was created" : "Task was marked as done"}

                        </p>
                        <p className="small-dark-secondary t-bold margin-top-4 ellipsis" style={{ width: "100%" }}> {x.tasktitle}</p>
                      </div>
                    </Grid>
                    <Grid item md={3} sm={12}>
                 <p className="small-dark-secondary">
                      {getFormattedDateTime(x.updateddate)}
                     </p>
                    </Grid>
                  </Grid>
                </div>)}
            </Grid>

          </Grid>
        </div>
      </div>
    );
  }
}
